@if (!data || (data?.plannedEvents.length === 0 && data?.realEvents.length === 0 && !(processStartEnd?.length > 0))) {
  <app-loading-and-no-data-template
    [isLoading]="!data"
    [height]="200"
  ></app-loading-and-no-data-template>
} @else {
  <div [style.height.px]="chartHeight">
    <highcharts-chart
      class="w-100 d-block"
      [Highcharts]="highcharts"
      [options]="chartOptions"
      [callbackFunction]="chartCallback">
    </highcharts-chart>
  </div>
}

